import { useTranslation } from 'react-i18next'
import { FileImportErrorKey, FileImportErrorCode } from 'shared/types'
import { kebabToCamel } from 'shared/utils'

const SUB_NAMESPACE = 'importFile'

type ErrorCodeTranslationMapping = Record<
  FileImportErrorCode,
  FileImportErrorKey
>

const errorKeysMapping: ErrorCodeTranslationMapping = {
  [FileImportErrorCode.fileIsEmpty]: FileImportErrorKey.fileIsEmpty,
  [FileImportErrorCode.fileRequired]: FileImportErrorKey.fileRequired,
  [FileImportErrorCode.invalidExtension]: FileImportErrorKey.invalidExtension,
  [FileImportErrorCode.fileTooLarge]: FileImportErrorKey.fileTooLarge,
  [FileImportErrorCode.tooFewColumns]: FileImportErrorKey.tooFewColumns,
  [FileImportErrorCode.duplicatedHeaders]: FileImportErrorKey.default,
  [FileImportErrorCode.missingHeader]: FileImportErrorKey.default,
  [FileImportErrorCode.noData]: FileImportErrorKey.default,
  [FileImportErrorCode.incorrectMappings]: FileImportErrorKey.default,
  [FileImportErrorCode.emptyCell]: FileImportErrorKey.default,
  [FileImportErrorCode.missingMapping]: FileImportErrorKey.default,
  [FileImportErrorCode.uploadFailed]: FileImportErrorKey.uploadFailed,
  [FileImportErrorCode.missingData]: FileImportErrorKey.missingData,
}

export const useFileErrorTranslation = () => {
  const { t } = useTranslation('errors')

  const isApiFileError = (errorCode: string) =>
    Object.keys(errorKeysMapping).includes(errorCode)

  const translate = (errorCode: string | FileImportErrorCode) =>
    t(
      `${SUB_NAMESPACE}.${
        isApiFileError(errorCode)
          ? errorKeysMapping[errorCode as FileImportErrorCode]
          : kebabToCamel(errorCode)
      }`
    )

  return { t: translate, isApiFileError }
}
